import React from 'react';
import axios from 'axios';
import  ClientPortal from "./ClientPortal";
import {formatPhone} from './ApplicationHelpers';
import { connect } from 'react-redux';
import { globalUpdateState } from './redux/actions';


class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            loaded:false,
            error:false,
            config:{}
        }
        var urlParams = {};
      (function () {
        // should be removed later on
        setTimeout(() => {
          const elements = document.getElementsByTagName('iframe')
          while (elements[0]) elements[0].parentNode.removeChild(elements[0])
        }, 1000)
          var e,
              a = /\+/g,  // Regex for replacing addition symbol with a space
              r = /([^&=]+)=?([^&]*)/g,
              d = function (s) {
                  return decodeURIComponent(s.replace(a, " "));
              },
              q = window.location.search.substring(1);

          while (e = r.exec(q))
              urlParams[d(e[1])] = d(e[2]);
      })();
        axios({
            method: 'get',
            url: '/92know/config',
            params:urlParams
          }).then(response => {
              let branding = this.makeBranding(response.data);
              if (urlParams.customize || urlParams.preview) {
                response.data.currentStep = 0;
                response.data.stepsOpened = 0;
                response.data.customize = true;
                console.log('response.data.customize', response.data.customize)
                // response.data.disableGetStarted = true;
              } else {
                // response.data.disableGetStarted = false;
              }
              props.globalUpdateState({loaded:true,form:response.data,branding});
          }, error => {
            let branding = this.makeBranding({});
                props.globalUpdateState({loaded:true,branding});
          });
    }
    makeBranding(config){
        let {branding,userBranding} = config;
        // console.log(userBranding)
        let darkColor = '#2d4a72 !important', lightColor= '#3b6297 !important', headerFontColor='#ffffff';

        if (userBranding && userBranding.beta && userBranding.beta.active) {
          userBranding = userBranding.beta;
        }

        if (userBranding && userBranding.active) {
          darkColor = userBranding.websiteDarkColor ;
          lightColor= userBranding.websiteLightColor;
          headerFontColor = userBranding.websiteDarkColor ? userBranding.headerFontColor:'#ffffff';
          branding = {
            active:true,
            name: userBranding.websiteName ? userBranding.websiteName : branding.title ,
            logo: (userBranding.active && userBranding.websiteLogoFileUrl) ? userBranding.websiteLogoFileUrl : branding.ra.titleIcon,
            phone: (userBranding.active ? (userBranding.phoneNumber || '') : (branding.phone ? branding.phone : '800-854-6621')),
            background: `linear-gradient(to right, ${darkColor}, ${lightColor}, ${userBranding.websiteDarkColor})`,
            color: `${headerFontColor} !important`,
            darkColor,
            lightColor,
            headerFontColor,
            ...userBranding
          }
          if(branding.name.indexOf('Income Maximizer') > -1 || branding.name.indexOf('Retirement Analyzer') > -1){
            branding.name = '';
          }
        } else {
          branding={
            active:false,
            name:'',
            phone:'800-854-6621',
            logo:"/images/92know.png",
            background:'url(/images/header-bg.jpg) no-repeat center top',
            color:'#FFFFFF',
            darkColor,
            lightColor,
            headerFontColor
          }
        }
        return branding;
    }
    async UNSAFE_componentWillMount(){

    }
    render(){
        // console.log(this.state.config)
        return (
          <React.Fragment>
            {this.props.loaded && <ClientPortal />}
            {!this.props.loaded && <div className="loading_txt">Loading, please wait...</div>}
            {this.props.error && <h1>{this.props.error}</h1>}
          </React.Fragment>
        );
    }
}
const mapStateToProps = (state /*, ownProps*/) => {
  return {
      ...state.mainState
  }
}

const mapDispatchToProps = { globalUpdateState }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main)
